<template>
    <div class="kingpin-item" :class="{ disabled: !this.kingpin.isWithinTolerance }" v-if="this.inputType === 'pin' || this.kingpin.isWithinTolerance ">
        <h2 class="kingpin-title">{{ this.kingpin.title }}</h2>
        <hr>

        <div class="sizing">
            <p v-if="inputType === 'vehicle'" class="pin-type">
                <span class="title">Pin Type:</span> {{ this.kingpin['pin-type'].toUpperCase() }}
            </p>
            <p class="length">
                <span class="title">Length:</span> {{ this.kingpin.length }}"
                <span class="deviation" v-if="inputType === 'pin' && this.kingpin.deviation.length.amount !== 0">
                    ({{this.deviationSymbol(this.kingpin.deviation.length.direction)}}{{this.kingpin.deviation.length.amount}}")
                </span>
            </p>
            <p class="diameter">
                <span class="title">Diameter:</span> {{ this.kingpin.diameter }}"
                <span class="deviation" v-if="inputType === 'pin' && this.kingpin.deviation.diameter.amount !== 0">
                    ({{this.deviationSymbol(this.kingpin.deviation.diameter.direction)}}{{this.kingpin.deviation.diameter.amount}}")
                </span>
            </p>
        </div>

        <div class="details" v-if="hasDetails">
            <div class="detail" v-if="this.kingpin['spindle-size']">
                <h4 class="title">Spindle Bore Size</h4>
                <p>{{this.kingpin['spindle-size']}}</p>
            </div>
            <div class="detail" v-if="this.kingpin['eye-beam-size']">
                <h4 class="title">Eye-Beam Bore Size</h4>
                <p>{{this.kingpin['eye-beam-size']}}</p>
            </div>
            <div class="detail" v-if="this.kingpin['install-tool']">
                <h4 class="title">Lip Seal Install Tool</h4>
                <p>{{this.kingpin['install-tool']}}</p>
            </div>
        </div>

        <h4 class="tolerance-warning" v-if="!this.kingpin.isWithinTolerance">Out of Tolerance</h4>
    </div>
    <div v-else>
        <h4 class="no-kingpins">None Available</h4>
    </div>
</template>

<script>

export default {
    name: "KingpinItem",
    props: {
        kingpin: {
            type: Object,
            required: true,
        },

        /**
         * The number of times the prop data has been updated.
         * Used to force component re-rendering
         */
        timesUpdated: {
            type: Number,
            default: 0,
            required: true
        },

        inputType: {
            type: String,
            default: 'pin',
        }
    },
    methods: {
        /**
         * Re-render the component
         */
        forceUpdate() {
            this.$forceUpdate();
        },

        /**
         * Deviation Symbol
         * Takes the deviation direction and returns a symbol
         * @return string
         */
        deviationSymbol(direction) {
            if (direction === 'upper') {
                return '-';
            } else if (direction === 'lower') {
                return '+';
            }
        }
    },
    computed: {
        /**
         * Computed: Pin Type
         * Changes the pin type to uppercase
         * @return string
         */
        pinType(){
          return this.kingpin['pin-type'].toUpperCase()
        },

        /**
         * Computed: Products
         * Takes the select value of the product and formats it for display
         * @return string
         */
        productFormatted() {
            if (this.kingpin.product === 'econokit'){
                return "ECONO KIT™ Bushing Kit";
            } else if (this.kingpin.product === 'qwikkit') {
                return "QwikKit® King Pin Kit";
            } else if (this.kingpin.product === 'pluskit') {
                return "PlusKit® King Pin Kit";
            } else {
                return this.kingpin.product;
            }
        },

        /**
         * Computed: Kingpin Details
         * Check if the Kingpin has any details
         * @return boolean
         */
        hasDetails(){
            return !!(this.kingpin['spindle-size'] || this.kingpin['eye-beam-size'] || this.kingpin['install-tool']);
        }
    },
    watch: {
        /**
         * Watches for the timesUpdated prop to change and re-renders the component
         */
        timesUpdated() {
            this.forceUpdate();
        },
    }
}
</script>

